// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"9208a840","484":"1bef058b","551":"2a37cce4"}[chunkId] + ".chunk.js";
};